module["exports"] = [
  "ala",
  "açıq bənövşəyi",
  "ağ",
  "mavi",
  "boz",
  "bənövşəyi",
  "göy rəng",
  "gümüşü",
  "kardinal",
  "narıncı",
  "qara",
  "qırmızı",
  "qəhvəyi",
  "tünd göy",
  "tünd qırmızı",
  "xlorofil",
  "yaşıl",
  "çəhrayı"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/az/commerce/color.js
// module id = 173
// module chunks = 0